import React from "react";
import { useSelector } from "react-redux";

import "./numberQuestion.scss";

const NumberQuestion = () => {
  const { list, currentIndex } = useSelector((state) => state.questions);
  return (
    <div className="bg-question">
      {/* <h6>{`Question ${getCurrentQuestionNumberFromRedux}`}</h6> */}
      <h6>
        Question {currentIndex + 1} of {list.length}{" "}
      </h6>
    </div>
  );
};

export default NumberQuestion;
